import React from 'react';
import { Card, CardContent } from '../ui/card';

export default function DownloadSection() {
  return (
    <div className="py-20 bg-black/20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl font-bold mb-8 bg-gradient-to-r from-purple-400 to-purple-600 bg-clip-text text-transparent">Download Poppy Poker</h2>
        <p className="text-xl text-gray-300 mb-12">Available on iOS and Android</p>
        
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <Card className="bg-black/40 border-purple-500/30 hover:border-purple-500/60 hover:bg-black/60 transition-all duration-300 shadow-2xl">
            <CardContent className="p-8">
              <div className="text-6xl mb-4">🍎</div>
              <h3 className="text-2xl font-semibold mb-4 text-purple-400">iOS App Store</h3>
              <p className="text-gray-300 mb-6">Download for iPhone and iPad</p>
              <a 
                href="https://apps.apple.com/us/app/poppy-poker/id6739791798" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-full bg-gradient-to-r from-yellow-500 to-red-600 hover:from-yellow-400 hover:to-red-500 text-black py-3 rounded-lg font-bold shadow-lg text-center block"
                style={{
                  background: 'linear-gradient(135deg,rgb(166, 134, 217) 0%, #5b21b6 100%)',
                  color: 'black',
                  padding: '12px 24px',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: 'bold',
                  textDecoration: 'none',
                  display: 'block',
                  transition: 'all 0.3s ease'
                }}
              >
                🍎 Download for iOS
              </a>
            </CardContent>
          </Card>
          
          <Card className="bg-black/40 border-purple-500/30 hover:border-purple-500/60 hover:bg-black/60 transition-all duration-300 shadow-2xl">
            <CardContent className="p-8">
              <div className="text-6xl mb-4">🤖</div>
              <h3 className="text-2xl font-semibold mb-4 text-purple-400">Google Play Store</h3>
              <p className="text-gray-300 mb-6">Download for Android devices</p>
              <a 
                href="https://play.google.com/store/apps/details?id=com.csw.poppypoker" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-full bg-gradient-to-r from-yellow-500 to-red-600 hover:from-yellow-400 hover:to-red-500 text-black py-3 rounded-lg font-bold shadow-lg text-center block"
                style={{
                  background: 'linear-gradient(135deg,rgb(166, 134, 217) 0%, #5b21b6 100%)',
                  color: 'black',
                  padding: '12px 24px',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: 'bold',
                  textDecoration: 'none',
                  display: 'block',
                  transition: 'all 0.3s ease'
                }}
              >
                🤖 Download for Android
              </a>
            </CardContent>
          </Card>
        </div>

        <div className="bg-black/40 border border-purple-500/30 rounded-2xl p-8">
          <h3 className="text-2xl font-semibold mb-4 text-purple-400">System Requirements</h3>
          <div className="grid md:grid-cols-2 gap-6 text-left">
            <div>
              <h4 className="font-semibold mb-2 text-purple-400">iOS Requirements</h4>
              <ul className="text-gray-300 space-y-1">
                <li>• iOS 12.0 or later</li>
                <li>• iPhone, iPad, or iPod touch</li>
                <li>• Internet connection required</li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-2 text-purple-400">Android Requirements</h4>
              <ul className="text-gray-300 space-y-1">
                <li>• Android 6.0 or later</li>
                <li>• 50MB available space</li>
                <li>• Internet connection required</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
